// Modules
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Components
import { AboutUsComponent } from './components/about-us/about-us.component';
import { FaqComponent } from './components/faq/faq.component';
import { HomeComponent } from './components/home/home.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
// import { WelcomeIntroComponent } from './components/welcome-intro/welcome-intro.component';

// Shop Pages
import { CategoryChildComponent } from './shop/category-child/category-child.component';
import { CheckoutComponent } from './shop/checkout/checkout.component';
import { SingleProductComponent } from './shop/single-product/single-product.component';
import { ViewAllComponent } from './shop/view-all/view-all.component';

// SagePay Pages
import { AcceptComponent } from './shop/sagepay/accept/accept.component';
import { DeclineComponent } from './shop/sagepay/decline/decline.component';
import { NotifyComponent } from './shop/sagepay/notify/notify.component';
import { RedirectComponent } from './shop/sagepay/redirect/redirect.component';

const routes: Routes = [
  {
    component: AcceptComponent,
    path: 'sagepay/accept'
  },
  {
    component: AboutUsComponent,
    path: 'how-it-work'
  },
  {
    component: CheckoutComponent,
    path: 'checkout'
  },
  {
    component: DeclineComponent,
    path: 'sagepay/decline'
  },
  {
    component: FaqComponent,
    path: 'faq',
  },
  {
    component: HomeComponent,
    // path: 'home'
    path: ''
  },
  {
    component: NotifyComponent,
    path: 'sagepay/notify'
  },
  {
    component: RedirectComponent,
    path: 'sagepay/redirect'
  },
  {
    component: ViewAllComponent,
    path: '::cat/view-all'
  },
  {
    component: ViewAllComponent,
    path: 'view-all'
  },
  {
    component: CategoryChildComponent,
    path: ':cat/:link',
    pathMatch: 'full'
  },
  {
    component: SingleProductComponent,
    path: ':category/:categoryChild/:link',
    pathMatch: 'full'
  },
  // {
  //   component: WelcomeIntroComponent,
  //   path: ''
  // },
  {
    component: NotFoundComponent,
    path: '**',
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(
    routes,
    {
      // enableTracing: true,
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      useHash: true
      // onSameUrlNavigation: 'reload',
      // scrollPositionRestoration: 'top'
    }
  )]
})

export class RoutingModule {}
